import React, { useState, useEffect } from 'react';
import KernteamLayout from '../../KernteamLayout';
import { host_url } from '../../App';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import './KindSpezialwunsch.css';

function KindSpezialwunsch() {
  const [zelte, setZelte] = useState([]);
  const [kinder, setKinder] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [einheiten, setEinheiten] = useState([]);

  const [selectedZeltId, setSelectedZeltId] = useState('');
  const [selectedKindId, setSelectedKindId] = useState('');
  const [selectedJobId, setSelectedJobId] = useState('');
  const [selectedEinheitId, setSelectedEinheitId] = useState('');

  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  // Zelte laden
  useEffect(() => {
    const fetchZelte = async () => {
      try {
        const response = await fetch(`${host_url}/zelte`);
        if (!response.ok) throw new Error('Zelte konnten nicht geladen werden.');
        const data = await response.json();
        setZelte(data);
      } catch (error) {
        setFeedback({ message: error.message, type: 'error' });
      }
    };
    fetchZelte();
  }, []);

  // Kinder laden, wenn ein Zelt ausgewählt wird
  useEffect(() => {
    if (selectedZeltId) {
      const fetchKinder = async () => {
        try {
          setKinder([]); // Kinderliste zurücksetzen, bevor neue geladen werden
          setSelectedKindId(''); // Ausgewähltes Kind zurücksetzen
          const response = await fetch(`${host_url}/kinder_formular_daten?zeltId=${selectedZeltId}`);
          if (!response.ok) throw new Error('Kinder für das ausgewählte Zelt konnten nicht geladen werden.');
          const data = await response.json();
          setKinder(data);
        } catch (error) {
          setFeedback({ message: error.message, type: 'error' });
          setKinder([]); // Kinderliste bei Fehler leeren
        }
      };
      fetchKinder();
    } else {
      setKinder([]); // Kinderliste leeren, wenn kein Zelt ausgewählt ist
      setSelectedKindId('');
    }
  }, [selectedZeltId]);

  // Jobs laden
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${host_url}/jobs_formular_daten`);
        if (!response.ok) throw new Error('Jobs konnten nicht geladen werden.');
        const data = await response.json();
        setJobs(data);
      } catch (error) {
        setFeedback({ message: error.message, type: 'error' });
      }
    };
    fetchJobs();
  }, []);

  // Einheiten laden, wenn ein Job ausgewählt wird
  useEffect(() => {
    if (selectedJobId) {
      const fetchEinheiten = async () => {
        try {
          // Reset einheiten and selectedEinheitId when job changes
          setEinheiten([]);
          setSelectedEinheitId('');
          const response = await fetch(`${host_url}/einheiten_formular_daten?jobId=${selectedJobId}`);
          if (!response.ok) throw new Error('Einheiten für den Job konnten nicht geladen werden.');
          const data = await response.json();
          setEinheiten(data);
        } catch (error) {
          setFeedback({ message: error.message, type: 'error' });
          setEinheiten([]); // Clear einheiten on error
        }
      };
      fetchEinheiten();
    } else {
      setEinheiten([]); // Clear einheiten if no job is selected
      setSelectedEinheitId('');
    }
  }, [selectedJobId]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedKindId || !selectedJobId || !selectedEinheitId) {
      setFeedback({ message: 'Bitte wähle ein Kind, einen Job und eine Einheit aus.', type: 'error' });
      return;
    }
    setIsLoading(true);
    setFeedback({ message: '', type: '' });

    try {
      const response = await fetch(`${host_url}/kinder/${selectedKindId}/spezialwunsch`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobId: selectedJobId, einheitId: selectedEinheitId }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Fehler beim Zuweisen des Spezialwunsches.');
      setSuccessMsg(data.message || 'Spezialwunsch (Job) erfolgreich zugewiesen!');
      setFeedback({ message: '', type: '' });
      // Optional: Formular zurücksetzen
      // setSelectedKindId('');
      // setSelectedJobId('');
      // setSelectedEinheitId('');
    } catch (error) {
      setFeedback({ message: error.message, type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <KernteamLayout>
      <div className="container kind-spezialwunsch-container">
        <BackArrow to="/arbeit" />
        <h1 className="section-title orange">Spezialwunsch erfüllen</h1>
        <p className="intro-paragraph">Wähle ein Kind, einen Job und eine spezifische Einheit aus, um diese Werte festzusetzen. Das ausgewählte Kind nimmt nicht an der Vergabe teil.</p>
        {feedback.message && <p className={`feedback ${feedback.type}`}>{feedback.message}</p>}
        <form onSubmit={handleSubmit} className="spezialwunsch-form">
          <div className="form-group">
            <label htmlFor="zelt-select">Zelt</label>
            <div className={`dropdown-wrapper ${selectedZeltId ? 'filled' : ''}`}>
              <select id="zelt-select" value={selectedZeltId} onChange={(e) => setSelectedZeltId(e.target.value)} required>
                <option value="" disabled>Wähle ein Zelt</option>
                {zelte.map(zelt => <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>)}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="kind-select">Kind</label>
            <div className={`dropdown-wrapper ${selectedKindId ? 'filled' : ''}`}>
              <select
                id="kind-select"
                value={selectedKindId}
                onChange={(e) => setSelectedKindId(e.target.value)}
                required
                disabled={!selectedZeltId || kinder.length === 0}>
                <option value="" disabled>Wähle ein Kind</option>
                {kinder.map(kind => <option key={kind.KindID} value={kind.KindID}>{kind.Name}</option>)}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="job-select">Job</label>
            <div className={`dropdown-wrapper ${selectedJobId ? 'filled' : ''}`}>
              <select id="job-select" value={selectedJobId} onChange={(e) => setSelectedJobId(e.target.value)} required>
                <option value="" disabled>Wähle einen Job</option>
                {jobs.map(job => <option key={job.JobID} value={job.JobID}>{job.Name}</option>)}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>
          {selectedJobId && einheiten.length > 0 && (
            <div className="form-group">
              <label htmlFor="einheit-select">Einheit </label>
              <div className={`dropdown-wrapper ${selectedEinheitId ? 'filled' : ''}`}>
                <select id="einheit-select" value={selectedEinheitId} onChange={(e) => setSelectedEinheitId(e.target.value)} required>
                  <option value="" disabled>Wähle eine Einheit</option>
                  {einheiten.map(einheit => <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>)}
                </select>
                <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
              </div>
            </div>
          )}
          {selectedJobId && einheiten.length === 0 && !isLoading && (
             <p>Für diesen Job sind aktuell keine spezifischen Einheiten verfügbar oder konnten nicht geladen werden.</p>
          )}
          <button type="submit" className="button_primary" disabled={isLoading || !selectedKindId || !selectedJobId || !selectedEinheitId}>
            {isLoading ? 'Speichert...' : 'Spezialwunsch zuweisen'}
          </button>
        </form>
      </div>
      <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default KindSpezialwunsch;
